export const CONSTANTS = {
  INPUT_CHARACTERS_LIMIT: 5000,
  LIMIT_TITLE_CHARACTERS: 250,
  MAX_WIDTH: 724,
  MIN_WIDTH: 724,
  MAX_WIDTH_WITH_MESSAGE: 570,
};
